/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/View',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel',
        'selectboxit/src/javascripts/jquery.selectBoxIt.min'
    ],
    function($, _, View, OptionModel, OptionValueModel) {
        return View.extend({
            $skus: null,
            $options: null,
            $sides: null,

            initialize: function(options) {
                this.$skus = this.$el.find('select.product-sku-select');
                this.$pageCountDropdown = this.$el.find('select.product-sides-select');
                this.$options = this.$el.find('.product-option-choices > ul');
                this.$details = this.$el.find('.product-details');

                this.defaultSkuId = options && options.defaultSkuId ? options.defaultSkuId : null;
                this.sides = options && options.sides ? options.sides : null;
                this._defaultsApplied = false;
                this._defaultSyncTriggered = false;

                // Set the model's selected side to the default if provided and not already set
                if (this.sides !== null && !this._defaultsApplied) {
                    this.setDefaultSideSelected(this.sides);
                }

                this.initEvents();
                this.render();
            },

            setDefaultSideSelected: function(defaultSides) {
                var sidesArr = this.model.get('sides');
                var found = false;
                sidesArr.forEach(function(side) {
                    if (side.get('sides') === defaultSides) {
                        side.set('selected', true);
                        found = true;
                    } else {
                        side.set('selected', false);
                    }
                });
                if (!found) {
                    // fallback: select the first side
                    if (sidesArr.length > 0) {
                        sidesArr[0].set('selected', true);
                    }
                }
            },

            initEvents: function() {
                var _this = this;
                this.listenToModel(this.model);

                this.$options.on('change', '.product-option-select', function() {
                    var $target = $(this);
                    var $optionContainer = $target.closest('[data-option-name]');
                    var optionName = $optionContainer.data('option-name');
                    var optionValueName = $target.val();

                    _this.model.get('eventAgent').trigger('PricingCalcItem:changeOption', optionValueName, optionName, _this.model);
                });

                this.$skus.on('change', function() {
                    _this.model.get('eventAgent').trigger('PricingCalcItem:changeSku', parseInt($(this).val()), _this.model);
                });

                this.$pageCountDropdown.on('change', function() {
                    _this.model.get('eventAgent').trigger('PricingCalcItem:changeSide', parseInt($(this).val()), _this.model);
                });

                this.$details.find('.details-toggle').on('click', function(e) {
                    var $collapse = $(this)
                        .parent()
                        .find('.details-collapse');
                    e.preventDefault();
                    if ($collapse.hasClass('open')) {
                        $collapse.removeClass('open').slideUp(300);
                        $(this).text($(this).data('message-show'));
                    } else {
                        $collapse.addClass('open').slideDown(300);
                        $(this).text($(this).data('message-hide'));
                    }
                });
            },

            /**
             * @param {PricingCalcItemModel} model
             */
            listenToModel: function(model) {
                var _this = this;
                this.listenTo(model, {
                    changed: function() {
                        _this.render();
                    },
                    optionChanged: function() {
                        _this.renderOptions();
                    }
                });
            },

            /**
             * @param {PricingCalcItemModel} model
             */
            setModel: function(model) {
                this.stopListening(this.model);
                this.model = model;
                this.listenToModel(model);
                this.render();
            },

            render: function() {
                this.renderSides();
                this.renderSkus();
                this.renderOptions();
            },

            renderSides: function() {
                var _this = this;
                var sidesHtml = this.model.get('sides').reduce(function(html, side) {
                    var sideVal = side.get('sides');
                    var selected = false;
                    // Only use default on first render if model has no selection
                    if (!_this._defaultsApplied && _this.sides !== null && sideVal === _this.sides) {
                        selected = true;
                    } else if ((_this._defaultsApplied || _this.sides === null) && side.get('selected')) {
                        selected = true;
                    }
                    return html + _this.sideOptionTmpl({
                        get: function(key) {
                            if (key === 'sides') return sideVal;
                            if (key === 'name') return side.get('name');
                            if (key === 'selected') return selected;
                            return side.get(key);
                        }
                    });
                }, '');

                this.$pageCountDropdown.closest('.product-choice').removeClass('loading');
                this.$pageCountDropdown.html(sidesHtml);
                // Set value to sides only on first render
                if (!_this._defaultsApplied && this.sides !== null) {
                    this.$pageCountDropdown.val(this.sides);
                } else {
                    // Always sync the dropdown value to the selected option
                    var selectedVal = this.model.get('sides').find(function(side) { return side.get('selected'); });
                    if (selectedVal) {
                        this.$pageCountDropdown.val(selectedVal.get('sides'));
                    }
                }
                this.$pageCountDropdown.selectBoxIt('refresh');
            },

            renderSkus: function() {
                var _this = this;
                var sideCount = this.model.getSelectedSide().get('sides');
                var pricingCalcSkus = this.model.get('skus').filter(function(pricingCalcSku) {
                    return pricingCalcSku.get('sku').get('sides') === sideCount;
                });
                var selectedSkuId = this.model.getSelectedSku && this.model.getSelectedSku().get('id');
                var skusHtml = pricingCalcSkus.reduce(function(html, pricingCalcSku) {
                    var skuId = pricingCalcSku.get('sku').get('id');
                    var selected = false;
                    // Only use default on first render if model has no selection
                    if (!_this._defaultsApplied && _this.defaultSkuId !== null && skuId === _this.defaultSkuId) {
                        selected = true;
                    } else if ((_this._defaultsApplied || _this.defaultSkuId === null) && pricingCalcSku.get('selected')) {
                        selected = true;
                    }
                    return html + _this.skuOptionTmpl(pricingCalcSku, _this.model, selected);
                }, '');

                this.$skus.closest('.product-choice').removeClass('loading');
                this.$skus.html(skusHtml);
                var shouldSyncDefault = false;
                // Set value to defaultSkuId only on first render
                if (!_this._defaultsApplied && this.defaultSkuId !== null) {
                    this.$skus.val(this.defaultSkuId);
                    shouldSyncDefault = true;
                } else if (selectedSkuId != null) {
                    this.$skus.val(selectedSkuId);
                }
                this.$skus.selectBoxIt('refresh');
                if (!_this._defaultSyncTriggered && shouldSyncDefault) {
                    this._defaultSyncTriggered = true;
                    this.$skus.trigger('change');
                }
                // Mark defaults as applied after first render of skus
                if (!_this._defaultsApplied) {
                    this._defaultsApplied = true;
                }
            },

            renderOptions: function() {
                var _this = this;
                this.clearOptionsElement();

                const isFoilActive = this.$el.find('.product-option-choices').data('feature-dvs-foil');

                this.model
                    .get('options')
                    .where({ enabled: true, visible: true })
                    .forEach(function(pricingCalcOption) {
                        const optionName = pricingCalcOption.get('option').get('name');

                        if (
                            !isFoilActive &&
                            (optionName === OptionModel.NAME_FRONT_FOIL_COLOR || optionName === OptionModel.NAME_BACK_FOIL_COLOR)
                        ) {
                            return;
                        }

                        const optionValues = pricingCalcOption.get('optionValues');

                        optionValues.forEach((pricingCalcOptionValue, index) => {
                            const optionValueName = pricingCalcOptionValue.get('optionValue').get('name');

                            if (
                                !isFoilActive &&
                                (optionValueName === OptionValueModel.NAME_FRONT_COATING_FOIL ||
                                    optionValueName === OptionValueModel.NAME_BACK_COATING_FOIL)
                            ) {
                                optionValues.remove(optionValues.at(index));
                            }
                        });

                        _this.optionTmpl(pricingCalcOption);
                    });

                this.$options.find('select').selectBoxIt({ autoWidth: false });
            },

            clearOptionsElement: function() {
                this.$options.html('');
            },

            /**
             * @param {PricingCalcSideModel} pricingCalcSide
             * @returns {function}
             */
            sideOptionTmpl: function(pricingCalcSide) {
                var tmpl = _.template(
                    ['<option value="<%- sides %>" <% if (selected) {%> selected<% } %>>', '<%- name %>', '</option>'].join('')
                );

                return tmpl({
                    sides: pricingCalcSide.get('sides'),
                    name: pricingCalcSide.get('name'),
                    selected: pricingCalcSide.get('selected')
                });
            },

            /**
             * @param {string} id
             * @param {string} valuesHtml
             * @returns {string}
             */
            getOptionHtml: function(id, valuesHtml) {
                return '<select id="' + id + '" class="product-option-select">' + valuesHtml + '</select>';
            },

            /**
             * To override
             * @param {PricingCalcSkuModel} pricingCalcSku
             * @param {PricingCalcItemModel} model
             * @param {boolean} selected
             * @returns {string}
             */
            skuOptionTmpl: function(pricingCalcSku, model, selected) {
                var sku = pricingCalcSku.get('sku');
                var id = sku.get('id');
                var name = sku.get('name');
                return '<option value="' + id + '" data-val="' + id + '"' + (selected ? ' selected' : '') + '>' + name + '</option>';
            },

            /**
             * To override
             * @param {PricingCalcOptionModel} pricingCalcOption
             * @returns {function}
             */
            optionTmpl: function(pricingCalcOption) {},

            /**
             * To override
             * @param {PricingCalcOptionValueModel} pricingCalcOptionValue
             * @returns {function}
             */
            optionValueTmpl: function(pricingCalcOptionValue) {}
        });
    }
);
